import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignUp,
  userTwitterSignIn,
} from "actions/Auth";
import { connect } from "react-redux";
import { hideAuthLoader, showAuthMessage } from "../actions";
import SignUpPage from "./SignUpPage";
import React from "react";
import {
  validPassword,
  validNumber,
  validOneUpperCase,
  validOneDot,
  validEightCharacter,
} from "../util/Regexes";

class SignUp extends React.Component {
  constructor() {
    super();
    this.state = {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      password: "",
      cPassword: "",
      merchant_code: "",
      phoneValidations: true,
      passwordValidations: false,
      emailValidations: false,
      are_guideline_accepted: false,
      isCommonPassword: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name === "email") {
      if (
        /^[~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/.test(value) ===
          true ||
        value === ""
      ) {
        this.setState({ ...this.state, [name]: value });
      }
    } else {
      this.setState({ ...this.state, [name]: value });
    }
    this.checkValidation(name, value);
  }

  checkValidation(name, value) {
    if (name === "phone") {
      const phoneRegex = new RegExp(/^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/);

      this.setState({ phoneValidations: phoneRegex.test(value) });
    }
    const commons = [
      "L58jkdjP!",
      "P@ssw0rd",
      "!QAZ2wsx",
      "1qaz!QAZ",
      "1qaz@WSX",
      "ZAQ!2wsx",
      "!QAZxsw2",
      "NICK1234-rem936",
      "xxPa33bq.aDNA",
      "!QAZ1qaz",
      "g00dPa$$w0rD",
      "Jhon@ta2011",
      "Nloq_010101",
      "1qazZAQ!",
    ];
    if (name === "password") {
      this.setState({
        passwordValidations: validPassword.test(value),
        isCommonPassword: commons.some((element) => element === value),
      });
    } else if (name === "email") {
      if (
        /^[~`!@#$%^&*()_+=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/.test(value) ===
          true ||
        value === ""
      ) {
        this.setState({
          emailValidations:
            value &&
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value),
        });
      }
    }
  }

  render() {
    const {
      first_name,
      last_name,
      phone,
      email,
      password,
      cPassword,
      merchant_code,
      are_guideline_accepted,
    } = this.state;

    const { showMessage, loader, alertMessage, success } = this.props;

    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <SignUpPage
          handleChange={this.handleChange}
          showAuthLoader={this.props.showAuthLoader}
          userSignUp={this.props.userSignUp}
          first_name={first_name}
          last_name={last_name}
          phone={phone}
          email={email}
          password={password}
          cPassword={cPassword}
          merchant_code={merchant_code}
          are_guideline_accepted={are_guideline_accepted}
          phoneValidations={this.state.phoneValidations}
          passwordValidations={this.state.passwordValidations}
          emailValidations={this.state.emailValidations}
          isCommonPassword={this.state.isCommonPassword}
          validNumber={validNumber}
          validOneUpperCase={validOneUpperCase}
          validOneDot={validOneDot}
          validEightCharacter={validEightCharacter}
          showMessage={showMessage}
          success={success}
          alertMessage={alertMessage}
        />
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}

        {/* <NotificationContainer /> */}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, success } = auth;
  return { loader, alertMessage, showMessage, authUser, success };
};

export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
  showAuthMessage,
  hideAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
})(SignUp);
